import { useExt } from "./ext";

export function useTraits(unit) {

    const ext = useExt();

    return ext.traits.filter(tr => {
        const match_a = tr.keywords_a.filter(ca => unit.categories.includes(ca)).length == tr.keywords_a.length;
        const match_r = tr.keywords_r.filter(cr => unit.categories.includes(cr)).length == 0

        return match_a && match_r;
    })
}